export const useMainLayoutTranslationsENUS = () => {
  const enUS = {
    menu: {
      profile: 'Profile',
      accountSettings: 'Account Settings',
      supportMode: 'Enter Support Mode',
      leaveSupportMode: 'Leave Support Mode',
    },
    main: {
      api: 'API',
      reports: 'Reports',
      devices: {
        title: 'Devices',
        deviceList: 'Device List',
      },
      healthCheck: 'Health Check',
      projections: {
        title: 'Projections',
        dashboard: 'Dashboard View',
      },
      groups: {
        title: 'Groups',
        chooseGroup: 'Create Groups',
      },
      deviceBlocks: 'Device Blocks',
      tagsManagement: 'Tags Management',
      settings: 'Settings',
    },
    settings: {
      overview: 'Overview',
      myAccount: 'My Account',
      loginSecurity: 'Login & Security',
      users: 'Users',
      audit: 'Audit',
    },
    developer: {
      title: 'Developer',
      sdk: 'SDK',
      batch: 'Batch',
      credentials: 'Credentials',
    },
    globalErrorBoundary: {
      title: 'Oops! Something went wrong',
      description: 'An unexpected error occurred. Our team has been notified.',
      contactSupport: 'Contact Support',
      tryAgain: 'Try Again',
    },
  };

  return enUS;
};
